import { useUserContext, useUserContextTracker } from '@vp/ubik-context'
import { useEffect } from 'react'

export const useFeatureFlag = (featureFlagKey: string, locales: string[]) => {
  const userContext = useUserContext()
  const tracker = useUserContextTracker()

  const featureFlag = userContext?.featureFlags?.[featureFlagKey]
  const isTargetedLocale = !locales || locales.length === 0 || locales.includes(userContext?.locale?.toLowerCase() ?? '')

  const isFeatureFlagEnabled = featureFlag === 'true' && isTargetedLocale

  useEffect(() => {
    if (featureFlag && isTargetedLocale) {
      tracker({
        type: 'featureFlag',
        name: featureFlagKey,
        enabled: featureFlag,
      })
    }
  }, [tracker, featureFlag, featureFlagKey, isTargetedLocale])

  return isFeatureFlagEnabled
}
